import api from "../apis/api";


class LanguageService {
    getLanguage(req) {
        return api.language.getLanguage(req);
    }
}

export default new LanguageService();